<template>
    <div class="mine"> 
        <div class="matchitems">
            <div class="block-title">我的交換</div>
            <div class="container">
                <div class="own-title">我發起的</div>
                <div class="own"> 
                     <exchangeItem :itemList = "myExchangeList" :isList="false"></exchangeItem>
                </div>
                <div class="join-title">我參與的</div>
                <div class="join">
                    <exchangeItem :itemList = "myApplyExchangeList" :isApply="true" :isList="false"></exchangeItem>
                </div>
            </div>
        </div>
        <div class="togetheritems">
            <div class="block-title">我的揪團</div>
            <div>
                <div class="own"> 
                    <togetherItem :itemList = "myTogetherList" :isList="false"></togetherItem>
                </div>
                <div class="join-title">我參與的</div>
                <div class="join">
                    <togetherItem :itemList = "myApplyTogetherList" :isApply="true" :isList="false"></togetherItem>
                </div>
            </div>
        </div>
        <div class="followingitems"></div>
    </div>
</template>

<script>
import { getMyExchangeItem } from '../../../api/user'; 
import exchangeItem from '../../Exchange/components/exchangeItem.vue'
import togetherItem from '../../Together/components/togetherItem.vue'
export default {
    components:{
        exchangeItem,
        togetherItem 
    },
    data(){
        return {
            myApplyExchangeList: [],
            myExchangeList: [],
            myTogetherList :[],
            myApplyTogetherList:[]
        }
    },  
    mounted(){
        this.getUserItemList()
    },  
    methods:{
        getUserItemList(){
            let params = {
                userName:this.$store.state.user.userName,
                type:''
            }
            getMyExchangeItem(params).then(res => {
                console.log(res);
                this.myApplyExchangeList = res.body.myApplyExchangeList
                this.myExchangeList = res.body.myExchangeList
                this.myApplyTogetherList = res.body.myApplyTogetherList
                this.myTogetherList = res.body.myTogetherList
                }).catch(err => {
                    console.log(err);
                });
        }
    }
}
</script>

<style lang='scss' scoped>
.mine {
    max-width: 1200px;
    margin: 0 auto;
    .block-title {
        display: inline-block;
        font-size: 30px;
        background-color: $mainColor;
        height: 60px;
        line-height: 60px;
        padding: 0 20px;
    }
    .own,.join {
        border: 1px solid $textColor;
        border-radius: 20px;
        margin: 20px 0;
    }
    .own-title,.join-title {
        color: $textColor;
        font-size: 20px;
        margin-top: 15px;
    }
}
</style>